import { usePlatform, useCreatorOn } from "@/lib/platform";
import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { InstallButton } from "@/components/layout/InstallButton";

const COLS = [
  { title: "Watch", links: [["Originals", "/originals"], ["Movies", "/movies"], ["Series", "/series"], ["Shorts", "/shorts"]] },
  { title: "AETRYX", links: [["Create", "/create"], ["Live Events", "/live-events"], ["Pricing", "/pricing"]] },
  { title: "You", links: [["My Library", "/library"], ["Search", "/search"], ["Account", "/account"], ["Profiles", "/profiles"]] },
  { title: "AETRYX", links: [["About", "/about"], ["Support", "/support"], ["Notifications", "/notifications"]] },
];

const FooterTag = () => { const p = usePlatform(); return <span data-testid="footer-tagline" className="font-display tracking-[0.3em] text-[#D4AF37]/80">{(p.name || "AETRYX").toUpperCase()} — {(p.tagline || "Watch. Create. Publish.").toUpperCase()}</span>; };

export const Footer = () => {
  const creatorOn = useCreatorOn();
  return (
  <footer data-testid="site-footer" className="relative mt-20 border-t border-[#D4AF37]/20 bg-[#0B0B0D]">
    <div className="mx-auto max-w-[1680px] px-4 sm:px-6 lg:px-10 py-14 grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_repeat(4,1fr)]">
      <div className="space-y-5">
        <Logo testId="footer-logo" />
        <p className="eyebrow !text-[0.7rem] !tracking-[0.4em]">A New World of Entertainment</p>
        <p className="text-sm text-[#8B8B8B] max-w-xs leading-relaxed">Watch movies. Create movies. Build your own cinematic universe.</p>
        <InstallButton testId="footer-install-btn" />
      </div>
      {COLS.map((c) => (
        <div key={c.title}>
          <h4 className="font-display text-sm tracking-[0.25em] uppercase text-[#D4AF37] mb-4">{c.title}</h4>
          <ul className="space-y-2.5">
            {c.links.filter(([, to]) => creatorOn || !to.startsWith("/create")).map(([label, to]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-white/70 hover:text-[#FFD86A] transition-colors">{label}</Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="gold-hairline" />
    <div className="mx-auto max-w-[1680px] px-4 sm:px-6 lg:px-10 py-6 flex flex-col sm:flex-row gap-2 items-center justify-between text-xs text-[#8B8B8B]">
      <FooterTag />
      <span>© 2026 AETRYX AI Studios. All rights reserved.</span>
    </div>
  </footer>
);
};
